import { useState, useEffect } from 'react';
import utils from '../../utils';
export default function useConstructorMode() {
  var store = utils.getQAPI();
  return store.constructorMode;
}